<template>
  <div class="sf-view sf-form sf-form--narrow">
    <loading v-if="loadingRender"></loading>

    <div v-if="ErrorList.length > 0" class="sf-notice sf-notice--danger">
      <i class="fas fa-exclamation-circle"></i>
      <ul>
        <li v-for="(item, key) in ErrorList" :key="key">{{ item.message }}</li>
      </ul>
    </div>

    <section class="sf-section">
      <h6 class="sf-section__title"><i class="fas fa-user"></i> مشخصات صاحب امضا</h6>
      <div class="sf-summary">
        <div class="sf-meta">
          <span class="sf-meta__label">صاحب امضا</span>
          <span class="sf-meta__value">{{ IntroduceInfo.fa_first_name + ' ' + IntroduceInfo.fa_last_name }}</span>
        </div>
        <div class="sf-meta">
          <span class="sf-meta__label">کد ملی</span>
          <span class="sf-meta__value">{{ IntroduceInfo.national_code }}</span>
        </div>
      </div>
    </section>

    <section class="sf-section">
      <h6 class="sf-section__title"><i class="fas fa-key"></i> رمز امضای دیجیتال</h6>
      <div class="sf-grid">
        <div class="sf-field">
          <label for="sign_pass">رمز امضای دیجیتال</label>
          <input id="sign_pass" type="password" v-model="pass" class="form-control text-center" dir="ltr" autocomplete="new-password" />
        </div>
        <div class="sf-field">
          <label for="sign_pass_rpt">تکرار رمز امضای دیجیتال</label>
          <input id="sign_pass_rpt" type="password" v-model="passrpt" class="form-control text-center" dir="ltr" autocomplete="new-password" />
        </div>
        <div class="sf-field sf-field--full">
          <ul class="sf-rules">
            <li>حداقل ۵ کاراکتر باشد.</li>
            <li>شامل حروف بزرگ و کوچک انگلیسی و عدد باشد.</li>
          </ul>
        </div>
      </div>
    </section>

    <div class="sf-actions">
      <button type="button" class="sf-btn sf-btn--secondary" @click="$emit('cancel')">انصراف</button>
      <button type="button" class="sf-btn sf-btn--primary" @click="submitCreateSing">ثبت رمز</button>
    </div>
  </div>
</template>
<script>
import Loading from '../../Tools/NetPa/Loading.vue'

export default {
  components: { Loading },
  props: ['IntroduceInfo'],
  data() {
    return {
      loadingRender: false,
      ErrorList: [],
      pass: '',
      passrpt: '',
      DataAxiosAdd: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        certificate_request_id: this.IntroduceInfo.request_id,
        national_code: this.IntroduceInfo.national_code,
        password: '',
      },
    }
  },
  methods: {
    submitCreateSing() {
      if (this.pass.length < 5) {
        this.$mySweetDefaultTost('هشدار', 'طول کلمه عبور نمیتواند کتر از 5 حرف باشد', 'error', 2500)
      } else if (!this.pass.match(/[A-Z]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل حروف بزرگ انگلیسی باشد', 'error', 2500)
      } else if (!this.pass.match(/[a-z]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل حروف کوچک انگلیسی باشد', 'error', 2500)
      } else if (!this.pass.match(/[0-9]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل اعداد باشد', 'error', 2500)
      } else if (this.pass != this.passrpt) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور و تکرارش همخوانی ندارند', 'error', 2500)
      } else {
        this.loadingRender = true
        this.DataAxiosAdd.password = this.pass
        var DataAxios = { method: 'POST', action: 'ElectronicSafte/CreateSign', arryfildValue: this.DataAxiosAdd }
        this.$PostData_netpatoken(DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.loadingRender = false
              this.$mySweetDefaultTost('ثبت موفق اطلاعات', 'امضای شما با موفقیت در سیستم ثبت شد', 'success', 2500)
              this.$emit('create_success', result.data)
            } else {
              this.loadingRender = false
              this.ErrorList = result.data
            }
          })
          .catch((error) => {
            this.loadingRender = false
            this.ErrorList = [{ message: 'مشکل ناشناخته دوباره تلاش کنید' }]
          })
      }
    },
  },
}
</script>
